import {Component, OnInit, Input, ChangeDetectorRef, ViewChild, ElementRef, ViewEncapsulation} from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
// import { NurseryService } from '../services/nursery.service';
import { NurseryService } from '../services/nursery.service.old';
import { ProductService } from '../services/product.service';
import { GoogleMapsService } from '../services/google-maps.service';
import { getSearchResults } from '../helpers/search.helper';
import { getNameWithCloserMatch } from '../helpers/search.helper';
import { getRatingAverage } from '../helpers/ratings.helper';
import { FiltersPipePipe } from '../filters/filters-pipe.pipe';
import { transformPhoneNumberToReadable } from '../helpers/stringTransform.helper';
import { getProductionType } from '../helpers/stringTransform.helper';
import { getPackagingType } from '../helpers/stringTransform.helper';
import { Nursery } from '../models/Nursery';
import { LocationService } from '../services/location.service';
import { SearchResultsService } from '../services/searchResults.service';
import { StatesService } from '../services/states.service.old';
import { MetersAsMilesPipe } from '../filters/metersAsMiles.pipe';
import { FilterPreferences } from '../models/FilterPreferences';
import { containerSizes } from './container-sizes';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import {
  faClock,
  faSquare,
  faCheckSquare
} from "@fortawesome/free-regular-svg-icons";

import {
  faAngleDown,
  faAngleUp,
  faArrowLeft,
  faBicycle,
  faBus,
  faCar,
  faChevronLeft,
  faChevronRight,
  faCompress,
  faDesktop,
  faEnvelopeOpen,
  faLongArrowAltLeft,
  faLongArrowAltRight,
  faMale,
  faMapMarker,
  faPhone,
  faSearch,
  faSearchPlus
} from "@fortawesome/free-solid-svg-icons";
import {ModalOptions} from "ngx-bootstrap";

@Component({
  selector: 'app-search',
  animations: [
    trigger(
      'sideMenuFade', [
        transition(':enter', [
          style({opacity: 0}),
          animate('250ms', style({opacity: 1}))
        ]),
        transition(':leave', [
          style({opacity: 1}),
          animate('250ms', style({opacity: 0}))
        ])
      ]
    )
  ],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  providers: [NurseryService, ProductService, GoogleMapsService, FiltersPipePipe, LocationService, MetersAsMilesPipe],
  encapsulation: ViewEncapsulation.None
})
export class SearchComponent implements OnInit {
  @Input() centerMap: Function;
  @Input() displayDirections: Function;
  @Input() removeDirections: Function;
  @Input() openPinInfo: Function;
  @Input() showMarkersGivenIds: Function;
  @Input() showAllMarkers: Function;

  @ViewChild('lightboxModal') lightboxModalRef: ElementRef;

  faAngleDown = faAngleDown;
  faAngleUp = faAngleUp;
  faArrowLeft = faArrowLeft;
  faBicycle = faBicycle;
  faBus = faBus;
  faCar = faCar;
  faCheckSquare = faCheckSquare;
  faChevronLeft = faChevronLeft;
  faChevronRight = faChevronRight;
  faClock = faClock;
  faCompress = faCompress;
  faDesktop = faDesktop;
  faEnvelopeOpen = faEnvelopeOpen;
  faLongArrowAltLeft = faLongArrowAltLeft;
  faLongArrowAltRight = faLongArrowAltRight;
  faMale = faMale;
  faMapMarker = faMapMarker;
  faPhone = faPhone;
  faSearch = faSearch;
  faSearchPlus = faSearchPlus;
  faSquare = faSquare;


  sideMenuToShow: boolean | string = false;
  showSearchNarrowMenu = false;
  searchModel = '';
  searchModelReadOnly = '';
  nurseryRatingData = [];
  nurseryProduct = [];
  nurseryProductFiltered = [];
  nurseryProductDetailed = [];
  searchResults = {};
  dataSets = {
    productResults: [],
    nurseryResults: [],
    productTypes: [],
    productionTypes: [],
    packagingTypes: [],
    nurseryPhotos: [],
  };
  menuFilterInputs = {
    filterModelProducts: '',
    nurseryProductFilteredModel: '',
  };
  selectedNursery = {
    lat_lng: null,
    id: -1,
  };
  selectedNurseryPhotos = {
    photos: [],
    featuredId: null,
    selectedPhotoId: null,
    selectedPhoto:null
  };
  filterPreferences: FilterPreferences = {
    state: 'Oregon',
    maxDistance: 1000,
    openRequired: false,
    Oregon: true,
    Washington: true,
    initialized: false,
    containerSize: '',
    packagingType: '',
  };
  directions = {
    routes: null,
  };
  sortByObject = {
    selectedSortBy: 0,
    selectedSortByProducts: 0,
    options: [
      'Alphabetical',
      'Distance',
    ],
    optionsProducts: [
      'Relevance',
      // 'Genus',
      // 'Name',
      'Availability',
      'Distance'
    ]
  };
  selectedRoute;
  routeMode = "DRIVING";
  selectedProduct = {};
  productLocations = [];
  containerSizeList = containerSizes;
  packagingTypes = [];
  hintsOn = null;
  retainMenuStateObject: { closed: boolean, sideMenuToShow: string | boolean } = {
    closed: false,
    sideMenuToShow: false,
  };
  showModal = false;
  modalPhoto = null;

  lightboxModal: BsModalRef;

  transformPhoneNumberToReadableHtml(number) {
    return transformPhoneNumberToReadable(number);
  };
  constructor(private nurseryService: NurseryService,
    private productService: ProductService,
    private googleMapsService: GoogleMapsService,
    private filtersPipePipe: FiltersPipePipe,
    private ref: ChangeDetectorRef,
    private locationService: LocationService,
    private searchResultsService: SearchResultsService,
    private statesService: StatesService,
    private modalService: BsModalService) {
      // empty constructor
    }

  // ui functions
  toggleSideMenuOn(searchType = this.searchResults['keyWithBestScore']) {
    this.sideMenuToShow = searchType;
    if (searchType === 'nurseryResults') {
      console.log("nurseryResults type search", this.searchResults['resultsData']);
      this.searchResults['resultsData'] = this.filtersPipePipe.transform(this.searchResults['resultsData'], this.filterPreferences, null);
      this.searchResultsService.resultsData.next(this.filtersPipePipe.transform(this.searchResults['resultsData'], this.filterPreferences, null));
      this.showMarkersGivenIds(this.searchResults['resultsData'].map((nursery => (nursery.item || nursery).id)));
    }
    if (searchType === 'productResults') {
      console.log('productResults type search', this.searchResults['resultsData']);
      // this.showMarkersGivenIds(new Array(0));

      // const arrayOfLocationsToShow = this.searchResults['resultsData'].map((product => (product.item ? product.item.locations.map((location => location.id)) : product.locations.map((location => location.id)) )));
      let arrayOfLocationsToShow = new Array(0);
      // console.log(arrayOfLocationsToShow);
      // this.showMarkersGivenIds(arrayOfLocationsToShow);
      const locationMarkersArray = [];
      const locationNurseries = [];
      this.searchResults['resultsData'].map((product) => {
        (product.item || product).locations = this.filtersPipePipe.transform(this.getNurseriesWithProductId((product.item || product).id), this.filterPreferences, null);
        // (product.item || product).locations.map((nursery => locationMarkersArray.push(nursery.id)));

        (product.item || product).locations = (product.item || product).locations.filter(l => l.distanceToMe <= this.filterPreferences.maxDistance * 1609.344);

        (product.item || product).locations.map((productLocation) => {
          const nurseryProduct = this.nurseryProduct.filter((nurseryProduct => nurseryProduct.product_id === (product.item || product).id && nurseryProduct.nursery_id === productLocation.id))[0];

          if (!nurseryProduct) {
            console.log(productLocation);
          }

          productLocation.detailedProductInfo = this.nurseryProductDetailed.filter((product => product.nursery_product_id === nurseryProduct.id));
          arrayOfLocationsToShow.push(productLocation.id);
          locationNurseries.push(productLocation);
        })
      });
      this.searchResultsService.resultsData.next(this.searchResults['resultsData']);
      // locationMarkersArray.filter((el, i, a) => i === a.indexOf(el)) // https://gist.github.com/telekosmos/3b62a31a5c43f40849bb remove dupliates
      arrayOfLocationsToShow.filter((el, i, a) => i === a.indexOf(el)) // https://gist.github.com/telekosmos/3b62a31a5c43f40849bb remove dupliates
      // console.log(arrayOfLocationsToShow, 'Imp');
      this.showMarkersGivenIds(arrayOfLocationsToShow);
      // this.showMarkersGivenIds(locationMarkersArray);
    }
    this.ref.detectChanges();
  }

  toggleSideMenuOff() {
    this.sideMenuToShow = false;
    this.ref.detectChanges();
  }

  toggleSideMenuOffArrow() {
    this.retainMenuStateObject.sideMenuToShow = this.sideMenuToShow;
    this.retainMenuStateObject.closed = true;
    this.toggleSideMenuOff();
  }

  reopenSideMenu() {
    this.toggleSideMenuOn(this.retainMenuStateObject.sideMenuToShow);
  }

  toggleSearchNarrowMenuOn() {
    this.showSearchNarrowMenu = true;
  }

  toggleSearchNarrowMenuOff() {
    this.showSearchNarrowMenu = false;
  }

  getRatingObjectWithId(id) {
    return getRatingAverage(this.nurseryRatingData, id);
  }

  getFullStars(rating) {
    return this.getArrayGivenNumber(Math.floor(rating));
  }

  getHalfStar(rating) {
    let decimal = rating % 1;
    if (decimal > 0.25) return this.getArrayGivenNumber(1);
    return this.getArrayGivenNumber(0);
  }

  getEmptyStars(rating) {
    let decimal = rating % 1;
    if (decimal > 0.25) return this.getArrayGivenNumber(4 - Math.floor(rating)); // one less...
    return this.getArrayGivenNumber(5 - Math.floor(rating));
  }

  getArrayGivenNumber(number) {
    return Array(number).fill(0).map((x,i)=>i);
  }

  nurseryClicked(nursery) {
    this.showMarkersGivenIds([nursery.id]);
    this.toggleSideMenuOn('locationInfo')
    if (this.selectedNursery.id !== nursery.id) {
      this.selectedNursery = nursery;
      this.openPinInfo(nursery);
    }
    this.setNurseryPhotosWithId(nursery.id);
    this.selectedNursery = nursery;
    this.centerMap(nursery.lat_lng, 10);
    this.ref.detectChanges();
  }

  goToNurseryDirections(nursery) {
    this.removeDirections();
    this.toggleSideMenuOn('routes');
    this.googleMapsService.getDirections(this.routeMode, this.locationService.location.value, nursery.lat_lng, (data) => {
      this.directions = data;
      if (data.status === 'OK') {
        this.changeSelectedRoute(0);
        this.ref.detectChanges();
      }
    });
  }

  goToLocationInfo() {
    this.toggleSideMenuOn('locationInfo');
    this.removeDirections();
    this.centerMap(this.selectedNursery.lat_lng, 10);
  }

  changeSelectedRoute(index) {
    this.selectedRoute = this.directions.routes[index];
    this.displayDirections(this.directions, index);
    // this.ref.detectChanges();
  }

  changeTransportationMode(newMode) {
    this.routeMode = newMode;
    this.goToNurseryDirections(this.selectedNursery);
    // this.ref.detectChanges();
  }

  goToRouteDirections(route) {
    this.selectedRoute = route;
    this.toggleSideMenuOn('directions');
    // this.displayDirections(route);
  }

  goToNurseryProducts(id) {
    this.nurseryProductFiltered = this.getNurseryProductWithId(id, this.selectedNursery);
    console.log(this.nurseryProductFiltered);
    console.log(this.selectedNursery);
    this.toggleSideMenuOn('nurseryProductFiltered');
  }

  goToProductLocations(product) {
    this.selectedProduct = product;
    this.productLocations = product.locations;
    // this.productLocations = this.getNurseriesWithProductId(product.id);
    this.toggleSideMenuOn('productLocations');
    this.showMarkersGivenIds(this.productLocations.map((location => location.id)));
  }

  goToProductDetailedForNursery(selectedLocation) {
    console.log('this is the selected location ', selectedLocation);
    this.selectedNursery = selectedLocation;
    this.toggleSideMenuOn('productDetailedNursery');
    this.showMarkersGivenIds([selectedLocation.id]);
    this.centerMap(selectedLocation.lat_lng, 10);
  }

  goToProductDetailed(product) {
    this.selectedProduct = product;
    console.log('goToProductDetailed', this.selectedProduct);
    this.toggleSideMenuOn('productDetails');
    this.showMarkersGivenIds(product.locations.map((location => location.id)));
  }

  goToNurseryFromProductSearch(selectedLocation, product) {
    this.selectedProduct = product;
    console.log(this.selectedProduct);
    // this.toggleSideMenuOn('productDetails');
    // this.showMarkersGivenIds(product.locations.map((location => location.id)));
    console.log('this is the selected location ', selectedLocation);
    this.selectedNursery = selectedLocation;
    this.toggleSideMenuOn('productDetailedNursery');
    this.showMarkersGivenIds([selectedLocation.id]);
    this.centerMap(selectedLocation.lat_lng, 10);
  }

  goToNurseryProductDetails(product) {
    this.selectedProduct = product;
    this.toggleSideMenuOn('nurseryProductDetails');
  }

  showAllNurseries() {
    console.log('showAllNurseries')
    this.reset();
    this.searchResults = {
      resultsData: this.dataSets.nurseryResults,
      keyWithBestScore: 'nurseryResults',
    }
    this.searchResultsService.updateSearchResults({
      resultsData: this.dataSets.nurseryResults,
      nurseryResults: {},
      productResults: {},
      results: {},
      keyWithBestScore: 'nurseryResults'
    })
    this.toggleSideMenuOn();
  }

  showAllProducts() {
    this.reset();
    this.searchResults = {
      resultsData: this.dataSets.productResults,
      keyWithBestScore: 'productResults',
      nurseryResults: {},
      productResults: {},
      results: {},
    }
    this.toggleSideMenuOn();
  }

  getFullCorrectProductName(product) {
    const first = this.getCorrectProductNameToShow(product);
    const second = this.getCorrectSecondProductNameToShow(product);
    return first + (second ? `- ${second}` : '');
  }

  getCorrectProductNameToShow(product) {
    const nameArray = [
      product.name_common,
      product.name_scientific,
      product.name_genus,
    ];
    return getNameWithCloserMatch(nameArray, this.searchModelReadOnly) || product.name_common;
    // if (product.name_scientific) {
    //   return product.name_common + ' - ' + product.name_scientific;
    // } else {
    //   return product.name_common;
    // }
  }

  getCorrectSecondProductNameToShow(product) {
    const nameArray = [
      product.name_common,
      product.name_scientific,
      product.name_genus,
    ];
    const closerMatch = getNameWithCloserMatch(nameArray, this.searchModelReadOnly);
    return closerMatch ? nameArray.filter((name => name != closerMatch))[0] : null;

  }

  getStateGivenId(id) {
    return 'WA';
  }

  reset() {
    this.searchResults = {}
    this.searchModel = '';
    this.searchModelReadOnly = '';
    this.toggleSideMenuOff();
    this.menuFilterInputs = {
      filterModelProducts: '',
      nurseryProductFilteredModel: '',
    }
    this.showSearchNarrowMenu = false;
    this.retainMenuStateObject = {
      closed: false,
      sideMenuToShow: false,
    };
    this.showAllMarkers();
    this.ref.detectChanges();
  }
  toggleHelpHints(val) {
    this.hintsOn = val;
  }
  toggleSortByOption() {
    this.ref.detectChanges();
    this.sortByObject.selectedSortBy + 1 >= this.sortByObject.options.length ? this.sortByObject.selectedSortBy = 0 : this.sortByObject.selectedSortBy++;
    this.ref.detectChanges();
  }
  toggleSortByOptionProducts() {
    this.ref.detectChanges();
    this.sortByObject.selectedSortByProducts + 1 >= this.sortByObject.optionsProducts.length ? this.sortByObject.selectedSortByProducts = 0 : this.sortByObject.selectedSortByProducts++;
    this.ref.detectChanges();
  }

  getPhotoSrcUrl(photoObj) {
    return photoObj.featured_photo_thumb_url;
  }

  getProductPhotoThumbSrcUrl(photoObj) {
    return photoObj.featured_photo_thumb_url;
  }

  getProductPhotoSrcUrl(photoObj) {
    return photoObj.featured_photo_url;
  }

  setNurseryPhotosWithId(nurseryId) {
    console.log('setNurseryPhotosWithId');

    this.nurseryService.getNurseryPhotosId(nurseryId).then((data) => {
      this.selectedNurseryPhotos.photos = data;
      console.log(data);
      this.selectedNurseryPhotos.featuredId = this.getFeaturedPhotoId(this.selectedNurseryPhotos.photos);
      this.selectedNurseryPhotos.selectedPhotoId = this.selectedNurseryPhotos.photos[0] ? this.selectedNurseryPhotos.photos[0].id : null;
    });
  }

  getFeaturedPhotoId(photoArray) {
    if (!photoArray) return;
    for (let i = 0; i < photoArray.length; i++) {
      if (photoArray[i].featured === 1)
        return photoArray[i].id;
    }
    return null;
  }

  getPhotoSrcUrlWithId(id) {
    for (let i = 0; i < this.selectedNurseryPhotos.photos.length; i++) {
      if (this.selectedNurseryPhotos.photos[i].id == id)
        return this.getPhotoSrcUrl(this.selectedNurseryPhotos.photos[i]);
    }
    return `https://wsnla-front.dev.everbearingservices.com/vendor-location-photos/DEFAULT.png`;
  }

  // data functions
  searchEnter(event: Event) {
    event.preventDefault();
    document.getElementById("search-bar-input").blur();
    this.handleSearch();
  }

  goFromFilters() {
    console.log('goFromFilters', this.filterPreferences);
    if ((this.searchModel && this.searchModel.length > 0) || this.sideMenuToShow) {
      // @ts-ignore
      if (this.searchResults.keyWithBestScore === 'productResults') {
        this.showAllProducts();
      } else {
        this.handleSearch();
      }
    }
    console.log('toggling search narrow menu off');
    this.toggleSearchNarrowMenuOff();
  }

  openTab(url) {
    const win = window.open(url, '_blank');
    win.focus();
  }

  getNurseryProductWithId(id, nursery) {
    const filteredProductItemNumbers = this.nurseryProduct.filter((productItem) => {
      return productItem.nursery_id === id;
    }).map((productItem => productItem.product_id));
    const productWithId = this.dataSets.productResults.filter((productItem) => {
      return filteredProductItemNumbers.indexOf(productItem.id) > -1;
    });
    productWithId.map((product) => {
      // const x = this.nurseryProduct.filter(())
      const nurseryProduct = this.nurseryProduct.filter((nurseryProduct => nurseryProduct.product_id === product.id && nurseryProduct.nursery_id === nursery.id))[0];
      product.detailedProductInfo = this.nurseryProductDetailed.filter((product => product.nursery_product_id === nurseryProduct.id));
    });
    return productWithId;
  }

  getNurseriesWithProductId(id) {
    const nurseryIdsWithProduct = this.nurseryProduct.filter((productItem => productItem.product_id === id))
    .map((nurseryProductItem => nurseryProductItem.nursery_id)); // nursery ids with product id
    return this.dataSets.nurseryResults.filter((nursery => nurseryIdsWithProduct.indexOf(nursery.id) > -1))
  }

  handleSearch() {
    const dataSetsToSend = {
      nurseryResults: this.dataSets.nurseryResults.filter(n => n.distanceToMe <= this.filterPreferences.maxDistance * 1609.344),
      productResults: this.dataSets.productResults
    };

    if (this.searchModel === '') {
      console.log('blank search term', dataSetsToSend);
      this.searchResults = {
        resultsData: dataSetsToSend.nurseryResults,
        keyWithBestScore: 'nurseryResults',
      }
      this.searchResultsService.updateSearchResults({
        resultsData: dataSetsToSend.nurseryResults,
        nurseryResults: {},
        productResults: {},
        results: {},
        keyWithBestScore: 'nurseryResults'
      });
      this.toggleSideMenuOn();
      return;
    }

    const results = getSearchResults(this.searchModel, dataSetsToSend);
    this.searchResults = results;
    this.searchResultsService.updateSearchResults(results);
    this.searchModelReadOnly = JSON.parse(JSON.stringify(this.searchModel));
    this.toggleSideMenuOn();
  }

  handleSearchPassSearchModel(newSearchModel) {
    this.searchModel = newSearchModel;
    this.handleSearch();
  }

  getProductType(product) {
    // return getProductType(typeId, this.dataSets.productTypes);
    return product.getCategoryString();
  }
  getProductionType(typeId) {
    return getProductionType(typeId, this.dataSets.productionTypes);
  }

  getPackagingType(typeId) {
    return getPackagingType(typeId, this.dataSets.packagingTypes);
  }

  openModal(photo) {
    const options = new ModalOptions();
    options.class='lightbox-modal';
    if (photo.hasOwnProperty('url')) {
      this.modalPhoto = photo;
    } else {
      this.modalPhoto = {
        'url': photo.featured_photo_url,
        'thumb_url': photo.featured_photo_thumb_url
      }
    }
    this.lightboxModal = this.modalService.show(this.lightboxModalRef, options);
  }

  closeModal() {
    this.lightboxModal.hide();
  }

  refreshDataSets() {
    let p1 = this.nurseryService.getNurseryData();
    let p2 = this.nurseryService.getNurseryProductData();
    let p3 = this.productService.getProductData();
    let p4 = this.nurseryService.getNurseryProductDetailData();
    let p5 = this.nurseryService.getNurseryPhotos();
    p1.then((data) => {
      this.dataSets.nurseryResults = data;
      this.searchResultsService.updateResults(data);
    });
    p2.then((data) => {
      this.nurseryProduct = data;
      return data;
    });
    p3.then((data) => {
      this.dataSets.productResults = data;
      return data;
    });
    p4.then((data) => {
      this.nurseryProductDetailed = data;
      return data;
    });
    p5.then((data) => {
      this.dataSets.nurseryPhotos = data;
      return data;
    });

    return Promise.all([p1, p2, p3, p4, p5]);
  }

  ngOnInit() {
    this.nurseryService.getNurseryData().then((data: Nursery[]) => {
      this.dataSets.nurseryResults = data;
      this.searchResultsService.updateResults(data);
    });
    this.nurseryService.getNurseryProductData().then((data) => {
      this.nurseryProduct = data;
    });
    this.nurseryService.getNurseryProductDetailData().then((data) => {
      this.nurseryProductDetailed = data;
    });
    this.productService.getProductData().then((data) => {
      this.dataSets.productResults = data;
    });
    this.nurseryService.getNurseryPhotos().then((data) => {
      this.dataSets.nurseryPhotos = data;
    });
    this.productService.getProductTypes().then((data) => {
      this.dataSets.productTypes = data;
    });
    this.productService.getProductionTypes().then((data) => {
      this.dataSets.productionTypes = data;
    })
    this.productService.getPackagingTypes().then((data) => {
      this.dataSets.packagingTypes = data;
      this.packagingTypes = data;
    })
    this.statesService.getStates().then(states => {
      states.forEach(s => this.filterPreferences[s.state] = true);
    });
  }
}
